import React from "react";
import { UserRound, X } from "lucide-react";
import "./FriendRequestModal.css";

const FriendRequestModal = ({
 requester,
 onAccept,
 onDecline,
 onViewProfile,
 onClose,
}) => {
 if (!requester) return null;

 return (
  <div className="friend-request-modal-overlay" onClick={onClose}>
   <div
    className="friend-request-modal"
    onClick={(e) => e.stopPropagation()}
   >
    <button
     type="button"
     className="friend-request-modal-close"
     onClick={onClose}
    >
     <X size={20} />
    </button>

    <div className="friend-request-modal-avatar">
     {requester.profile_image ? (
      <img
       src={requester.profile_image}
       alt={requester.display_name || "Profile"}
      />
     ) : (
      <UserRound size={42} />
     )}
    </div>

       <h2>
         {`${requester.first_name || ""} ${requester.last_name || ""}`.trim() ||
           requester.display_name}
       </h2>

    <p>sent you a friend request.</p>

    <div className="friend-request-modal-actions">
     <button type="button" onClick={onAccept}>
      Accept
     </button>

     <button type="button" onClick={onDecline}>
      Decline
     </button>
    </div>

    <button
     type="button"
     className="friend-request-view-profile"
     onClick={onViewProfile}
    >
     View Profile
    </button>
   </div>
  </div>
 );
};

export default FriendRequestModal;